var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52 10C3.52 8.632 4.632 7.52 6 7.52H9.2V6H6C3.792 6 2 7.792 2 10C2 12.208 3.792 14 6 14H9.2V12.48H6C4.632 12.48 3.52 11.368 3.52 10ZM6.8 10.8H13.2V9.2H6.8V10.8ZM14 6H10.8V7.52H14C15.368 7.52 16.48 8.632 16.48 10C16.48 11.368 15.368 12.48 14 12.48H10.8V14H14C16.208 14 18 12.208 18 10C18 7.792 16.208 6 14 6Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.05868119fe1e6ec39958c6cfbebf1616.svg";
export { ForwardRef as ReactComponent };